<template>
  <div class="box-container">
    <div class="box-input">
      <div class="box-input-left">
        <el-input v-model="formInfo.title" clearable style="width: 220px;" placeholder="请输入标题"></el-input>
        <el-select v-model="formInfo.status" clearable placeholder="状态" @change="searchFn">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value" prefix-icon="el-icon-caret-top">
          </el-option>
        </el-select>
        <el-select class="box-input-left-z" style="width: 160px" clearable filterable v-model="formInfo.merchatId" placeholder="商户" @change="searchFn">
          <el-option v-for="item in continent" :key="item.id" :label="item.companyName" :value="item.id">
          </el-option>
        </el-select>
        <el-date-picker v-model="dateInfo" style="width: 260px" type="daterange" range-separator="至" start-placeholder="下单开始日期" end-placeholder="下单结束日期" @change="setDate" value-format="yyyy-MM-dd">
        </el-date-picker>

      </div>

      <div class="box-input-btn">
        <el-button class="default" @click="searchFn">搜索</el-button>
        <el-button class="box-input-btn-cz" @click="resetFn">重置</el-button>
        <!-- <el-button class="box-input-btn-cz" @click="editFn()">添加</el-button> -->
      </div>

    </div>

    <div class="box-table">
      <el-table :data="tableList" :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }" ref="refTable" style="width: 100%" 
      :height="$store.state.product.screen ? '820px' : '470px'" v-loading="formInfo.loading" :cell-style="{ 'text-align': 'center' }">

        <el-table-column prop="orderNo" label="订单号">
        </el-table-column>
        <el-table-column prop="productTile" label="标题">
        </el-table-column>
        <el-table-column prop="amount" label="订单金额" align="left">
          <template slot-scope="scope">
            <div>
              <span class="status-bom-left" v-if="scope.row.status !== 0">已付：￥{{ scope.row.amount }}</span>
              <span class="status-bom-left" v-else>应付：￥{{ scope.row.amount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="订单状态">
          <template slot-scope="scope">
            <el-tag size="samll" :type="setStatusColor(scope.row.status)">{{ scope.row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="起保日期/天数" min-width="100px">
          <template slot-scope="scope">
            <div>{{$moment(new Date(scope.row.startTime)).format("YYYY-MM-DD")}}</div>
            <el-link :underline="false" type="primary">投保{{scope.row.days}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="details" label="参保人信息" align="left" min-width="130px">
          <template slot-scope="scope">
            <div class="status-user">
              <div class="status-user-item" v-for="(elem, idx) in scope.row.details" :key="idx">
                <div class="user-info">
                  <span>{{ elem.name }}</span>
                  <span class="user-type">{{ elem.type == 1 ? '身份证' : '护照' }}</span>

                </div>
                <div class="user-info">{{ elem.idNumber }}</div>
              </div>
              <div class="status-date" v-if="scope.row.insuranceStatTime">
                保障期限
                {{ scope.row.insuranceStatTime && scope.row.insuranceStatTime.split(' ')[0] }}
                至
                {{ scope.row.insuranceEndTime && scope.row.insuranceEndTime.split(' ')[0] }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下单信息" min-width="130px">
          <div slot-scope="scope" style="transform: scale(0.8);">
            <div v-if="scope.row.insuranceNo">{{scope.row.insuranceNo}}</div>
            <div v-if="scope.row.insuranceStatTime">{{ $moment(new Date(scope.row.insuranceStatTime)).format("YYYY-MM-DD
              HH:mm:mm") }}</div>
            <div v-if="scope.row.insuranceEndTime">{{ $moment(new Date(scope.row.insuranceEndTime)).format("YYYY-MM-DD
              HH:mm:mm") }}</div>
          </div>
        </el-table-column>
        <el-table-column prop="email" label="客户邮箱">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="edit-wrap">
              <div class="edit-item">
                <span class="lan" @click="renewIinsurance(scope.row)" v-if="scope.row.status == 11">投保</span>
                <span class="copy" v-if="[-3,2,3,4,11].includes(scope.row.status)" @click="outPriceFn(scope.row)">退款</span>
                <!-- <span class="del" v-if="[-2,-1,0].includes(scope.row.status)"  @click="delFn(scope.row.id)">删除</span> -->
                <span class="lan" @click="toEmailFn(scope.row)">发送邮箱</span>
                <!-- v-if="[2, 3, 4].includes(scope.row.status)"  -->
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="box-table-pagination">
      <el-pagination :current-page="formInfo.pageIndex" :page-size="formInfo.pageSize" @current-change="currentSizeChange($event, formInfo.pageSize)" @size-change="currentSizeChange(formInfo.pageIndex, $event)" layout="total, prev, pager, next, jumper" :total="formInfo.total">
      </el-pagination>
    </div>

    <!-- 退款 -->
    <el-dialog :visible.sync="outPricedio" width="419px" class="quan-dialog-out-class" :close-on-click-modal="true">
      <div class="dialog-member-title">
        <span class="dialog-member-name">退款操作</span>
        <div class="dialog-close" @click="outPricedio = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="quan-num-add" style="margin-top: 20px">
        <div class="quan-num-add-item">
          <span class="quan-num-add-title">退款金额</span>
          <div>
            <span>订单剩余{{ orderItem.amount }}元</span>
            <span class="quan-num-right" @click="outPrice.price = orderItem.amount">全部退款</span>
          </div>
        </div>

        <el-input type="Number" min="0.01" :max="orderItem.amount" class="quan-num-input" v-model="outPrice.price" @input="verification"></el-input>

        <div class="quan-num-add-item">
          <span class="quan-num-add-title">退款原因</span>
        </div>

        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="outPrice.text" class="quan-num-input" style="margin-bottom: 25px">
        </el-input>

        <div class="packge-btn-add">
          <el-button class="pageck-btn" @click="outPricedio = false">取消</el-button>
          <el-button class="pageck-btn default" type="primary" @click="outPriceSubmit">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <EditPage :visible="isEdit" :row="editRow" @refresh="getListFn" @close="isEdit = false"></EditPage>
  </div>
</template>

<script>
import { queryorderorg, orderrefund, insuranceorderstatusselect, insurance, sendemail } from '@/api/insurance.js';
import { merchatlist } from "@/api/orderCenter.js";
import EditPage from "./components/Edit.vue";

export default {
  components: { EditPage },
  data() {
    return {
      formInfo: {
        key: '',
        merchatId: '',
        status: '',
        startTime: '',
        endTime: '',
        pageIndex: 1,
        pageSize: 10,
        total: 0,

        loading: false,
      },
      isEdit: false,
      editRow: {},
      tableList: [],
      statusList: [],
      dateInfo: [],
      continent: [],
      orderItem: {},
      outPricedio: false,
      outPrice: { price: '' },
      timer: null,

    }
  },
  mounted() {
    this.getListFn();
    this.getDataFn();
  },
  computed: {
    setStatusColor() {
      return function (status) {
        if ([-3, 2, 3].includes(status)) {
          return 'success'
        } else if (status == 11) {
          return 'danger'
        } else if (status == 0 || status == 1) {
          return 'warning'
        } else {
          return 'info'
        }
      }
    }
  },
  methods: {
    getDataFn() {
      insuranceorderstatusselect().then(res => {
        this.statusList = res.data
      })
      // 商户
      merchatlist({}).then((res) => {
        this.continent = res.data;
      });
    },
    getListFn() {
      this.formInfo.loading = true;

      queryorderorg({
        key: this.formInfo.title,
        status: this.formInfo.status,
        supplierId: this.formInfo.merchatId,
        startTime: this.formInfo.startTime,
        endTime: this.formInfo.endTime,
        'Page.Size': this.formInfo.pageSize,
        'Page.Index': this.formInfo.pageIndex,
      }).then(res => {
        this.tableList = res.data.rows.map(item => {
          try {
            if (item.images) {
              item.images = JSON.parse(item.images)
            } else {
              item.images = []
            }
          } catch (error) {
            item.images = []
          }
          try {
            if (item.buttons) {
              item.buttonList = JSON.parse(item.buttons)
            } else {
              item.buttonList = []
            }
          } catch (error) {
            item.buttonList = []
          }
          return item
        });
        this.formInfo.total = res.data.total
        this.formInfo.loading = false;
      })
    },

    //验证退款金额
    verification(val) {
      if (val > this.orderItem.amount) {
        this.outPrice.price = this.orderItem.amount;
        return this.$message({
          message: "退款金额不能大于剩余金额",
          type: "warning",
        });
      }
      if (val <= 0) {
        this.outPrice.price = 0.01;
        return this.$message({
          message: "退款金额必须大于0",
          type: "warning",
        });
      }
    },
    setDate(e) {
      if (!e) {
        this.formInfo.startTime = "";
        this.formInfo.endTime = "";
      } else {
        this.formInfo.startTime = e[0];
        this.formInfo.endTime = e[1];
      }
      this.searchFn()
    },
    searchFn() {
      this.formInfo.pageIndex = 1
      this.getListFn()
    },
    resetFn() {
      this.dateInfo = []
      this.formInfo = {
        key: '',
        merchatId: '',
        status: '',
        startTime: '',
        endTime: '',
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        loading: false,
      }
      this.getListFn();
    },

    currentSizeChange(current, size) {
      this.formInfo.pageIndex = current
      this.formInfo.pageSize = size
      this.getListFn()

      this.$refs.refTable.bodyWrapper.scrollTop = 0
    },
    editFn(row = {}) {
      this.editRow = row;
      this.isEdit = true;
    },
    outPriceFn(item) {
      this.orderItem = item;
      this.outPricedio = true;
    },
    outPriceSubmit() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        orderrefund({
          amount: this.outPrice.price,
          refundRemarks: this.outPrice.text,
          id: this.orderItem.id,
        })
          .then((res) => {
            clearTimeout(this.timer);
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: "退款成功！",
                type: "success",
              });
              this.outPrice = {
                price: "",
                text: "",
              };
              this.outPricedio = false;
              this.searchFn();
            }
          })
          .catch(() => {
            clearTimeout(this.timer);
          });
      }, 200);
    },
    renewIinsurance(item) {

      let that = this
      that.$confirm(`投保失败，确定手动投保吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        insurance({ OrderId: item.id }).then(res => {
          if (res.code == 1) {
            that.$message.success('投保成功')
            that.searchFn()
          }
        }).catch((res) => { })
      })
    },
    delFn(id) {
      let that = this
      that.$confirm(`确定删除该数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderrefund({ id }).then(res => {
          console.log(res);

          if (res.code == 1) {
            that.$message.success('删除成功')
            that.searchFn()
          }
        }).catch((res) => { })
      })
    },
    toEmailFn(item) {
      let that = this
      this.$prompt('请输入邮箱', '发送保单到邮箱', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {

        sendemail({
          OrderId: item.id,
          email: value
        }).then(() => {
          that.$message.success('投保成功')
          done();
        })

      }).catch(() => { });
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  .quan-dialog-out-class {
    ::v-deep .el-dialog {
      background: none !important;
      border-radius: 12px;

      .el-dialog {
        background: none;
      }

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        width: 419px;

        // height: 285px;
        background: linear-gradient(
          180deg,
          #e7ecfb 0%,
          #f6f8fe 24%,
          #ffffff 100%
        );
        border-radius: 12px;
        box-sizing: border-box;
        overflow: hidden;
      }
    }

    .dialog-member-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: -10px;

      .dialog-member-name {
        font-size: 18px;
        font-weight: bold;
      }

      .dialog-close {
        width: 25px;
        height: 25px;
        background: #e0e0e0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .el-icon-close {
          color: #fff;
          font-size: 16px;
        }
      }
    }

    .quan-num-add {
      .quan-num-input {
        margin: 12px 0;
      }

      .quan-num-add-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .quan-num-add-title {
          font-size: 16px;
          margin-top: 12px;
        }

        .quan-num-right {
          margin-left: 16px;
          color: #3888e9;
          cursor: pointer;
        }
      }
    }
  }

  .box-input-left {
    ::v-deep .el-range-input {
      background: #f2f4f7;
      border: none;
    }
  }

  .box-input {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    width: 100%;

    ::v-deep .el-input__inner {
      background: #f2f4f7;
      border: none;
    }

    ::v-deep .el-select,
    .el-input {
      margin-right: 8px;
    }

    .box-input-btn {
      text-align: right;

      .box-input-btn-cz {
        background: #eaf3ff;
        color: #3888e9;
        border: none;
      }

      .box-input-btn-add {
        background: #d8f5e4;
        color: #54d8a5;
        border: none;
      }
    }
  }

  .box-table {
    .status-user {
      margin-top: 8px;

      .status-date {
        font-size: 12px;
        margin-top: 8px;
      }

      .status-user-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        .user-info {
          text {
            &:nth-child(1) {
              font-size: 12px;
            }

            &:nth-child(2) {
              font-size: 12px;
              color: #999999;
              margin-left: 8px;
            }
          }
        }

        .user-type {
          display: inline-block;
          color: #0077ff;
          padding: 0 4px;
          background: #e4edfb;
          font-size: 12px;
          border-radius: 4px;
          transform: scale(0.8);
        }
      }
    }

    .status-bom-left {
      color: #fa541c;
    }

    .edit-wrap {
      .edit-item {
        // padding-left: 20px;
        white-space: nowrap;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        span {
          cursor: pointer;
          display: inline-block;
          margin: 0 2px;

          &.lan {
            color: #3888e9;
          }

          &.copy {
            color: #9ea09e;
          }

          &.del {
            color: #e41313;
          }
        }
      }
    }
  }

  .box-table-pagination {
    text-align: center;
    margin-top: 16px;
  }
}
</style>